import React from 'react'
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export const Protected = (props) => {
    const { Cmd } = props;
    const navigate = useNavigate();

    useEffect(() => {
        const token = localStorage.getItem('token')
        if (!token) {
            navigate('/')
        }
    }, [navigate])

    return (
        <div>

            <Cmd />

        </div>
    )
}
export default Protected;